/** 商品服务错误日志处理状态 */
export enum GOODS_SERVICE_ERROR_LOG_STATE_ENUM {
  /** 已失败 */
  FAIL = '-1',
  /** 已处理 */
  HANDLE = '1',
  /** 未处理 */
  UN_HANDLE = '0',
}

export const GOODS_SERVICE_ERROR_LOG_STATE_LIST = [
  {
    label: '未处理',
    value: GOODS_SERVICE_ERROR_LOG_STATE_ENUM.UN_HANDLE,
  },
  {
    label: '已处理',
    value: GOODS_SERVICE_ERROR_LOG_STATE_ENUM.HANDLE,
  },
  {
    label: '已失败',
    value: GOODS_SERVICE_ERROR_LOG_STATE_ENUM.FAIL,
  },
];

export enum GOOSD_SERVICE_GOODS_STATE_ENUM {
  /** 临时商品 */
  TEMPORARY = '10',
  /** 待认证商品 */
  UNAUTHORIZED = '20',
  /** 已认证商品 */
  AUTHORIZED = '30',
}
export const GOOSD_SERVICE_GOODS_STATE_LIST = [
  {
    label: '临时商品',
    value: GOOSD_SERVICE_GOODS_STATE_ENUM.TEMPORARY,
  },
  {
    label: '待认证商品',
    value: GOOSD_SERVICE_GOODS_STATE_ENUM.UNAUTHORIZED,
  },
  {
    label: '已认证商品',
    value: GOOSD_SERVICE_GOODS_STATE_ENUM.AUTHORIZED,
  },
];
